import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCompanyBlogsCountBySlug = async (slug, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  try {
    const {
      data: { count },
    } = await axios.get(`/api/public/companies/${slug}/blogs/count?${queryString}`);

    return { count };
  } catch (error) {
    console.log(error);
  }

  return { count: 0 };
};

const defaultQueryParams = {
  includeInactive: false,
  queryOptions: {},
};

export const useRelatedBlogsCountBySlug = (slug, queryParams = {}) => {
  const { includeInactive, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    includeinactive: includeInactive,
  };

  return useQuery(
    `company-${slug}-blogs-count`,
    () => getCompanyBlogsCountBySlug(slug, queryStringParams),
    {
      //@ts-ignore
      select: ({ count }) => ({ count }),
      initialData: { count: 0 },
      ...queryOptions,
    }
  );
};